import { createAction } from "redux-actions";
import { SET_LOYALTY_IS_BENEFIT_EVENT_ACTIVE } from "../constants";

const setIsBenefitEventActive = createAction(
  SET_LOYALTY_IS_BENEFIT_EVENT_ACTIVE,
  (isBenefitActive, benefitType) => ({
    [benefitType]: isBenefitActive
  })
);

export default setIsBenefitEventActive;
